import { render, staticRenderFns } from "./font-size-handler.vue?vue&type=template&id=0a9f3910&scoped=true&"
import script from "./font-size-handler.vue?vue&type=script&lang=js&"
export * from "./font-size-handler.vue?vue&type=script&lang=js&"
import style0 from "./font-size-handler.vue?vue&type=style&index=0&id=0a9f3910&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9f3910",
  null
  
)

export default component.exports